import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface IResetLoginRateLimitingOnSiteUsersParams {
  siteUserIds?: string[];
}

export interface IResetLoginRateLimitingOnSiteUsersResult extends IResult {
}

export class ResetLoginRateLimitingOnSiteUsersRequest extends Request<IResetLoginRateLimitingOnSiteUsersParams, IResetLoginRateLimitingOnSiteUsersResult> {
  constructor(params: IResetLoginRateLimitingOnSiteUsersParams) {
    super('resetLoginRateLimitingOnSiteUsers', params);
  }
}
